import _ from "lodash";
export const getCurriculumProgramIdFromState = ({ state }) => {
  return _.get(state, ["platform", "currentCurriculumProgram", "id"]);
};
